module.exports = __webpack_public_path__ + "img/asanmobile1.36468a69.jpeg";